<!-- @format -->

<template>
	<component
		:is="getWidgetName(item.pcProps.defaultValueType || item.type, name)"
		v-model="value"
		v-bind="bindPcProps[0]"
		:pc-props="bindPcProps[1]"
	/>
</template>

<script setup lang="ts">
	import { useBaseConfigStoreWithOut } from '../../config';
	import { getWidgetName } from '.';
	import type { BasicField, WidgetConfigType } from '../../types';

	interface Props {
		modelValue: any;
		pcProps: WidgetConfigType;
		item: BasicField;
	}

	const props = withDefaults(defineProps<Props>(), {
		modelValue: '',
	});

	const emit = defineEmits(['update:modelValue']);

	const name = inject<string>('name');

	const baseConfigStore = useBaseConfigStoreWithOut(name);

	const DONT_BIND_PC_PROPS = ['rows', 'isPassword', 'showPassword'];

	const value = computed({
		get() {
			return props.modelValue;
		},
		set(val) {
			emit('update:modelValue', val);
		},
	});

	const bindPcProps = computed(() => {
		const pcProps: [Partial<WidgetConfigType>, Partial<WidgetConfigType>] = [{}, {}];
		for (const [key, value] of Object.entries(props.item.pcProps)) {
			// 有些属性不需要绑定在defaultValue框内
			if (!DONT_BIND_PC_PROPS.includes(key)) {
				if (baseConfigStore.getFieldsBindpcProps().includes(key)) {
					pcProps[0][key] = value;
				} else {
					pcProps[1][key] = value;
				}
			}
		}
		return pcProps;
	});
</script>

<style scoped></style>
